export const COLOR_SCHEME_COOKIE_NAME = 'medable-color-scheme';
export const DARK_MODE_CLASSES = ['dark', 'nucleus-dark'];
const SHARED_COOKIE_ROOT_DOMAINS = ['medable.com', 'medable.cn'];
const COLOR_SCHEME_COOKIE_MAX_AGE = 365 * 24 * 60 * 60;
const getSharedCookieDomain = (hostname) => {
    const rootDomain = SHARED_COOKIE_ROOT_DOMAINS.find((domain) => hostname === domain || hostname.endsWith(`.${domain}`));
    return rootDomain ? `.${rootDomain}` : null;
};
const getColorSchemeMediaQuery = () => {
    return typeof window !== 'undefined' && typeof window.matchMedia === 'function'
        ? window.matchMedia('(prefers-color-scheme: dark)')
        : null;
};
export const getSystemColorScheme = () => {
    var _a;
    return ((_a = getColorSchemeMediaQuery()) === null || _a === void 0 ? void 0 : _a.matches) ? 'dark' : 'light';
};
export const getStoredColorScheme = () => {
    var _a;
    if (typeof document === 'undefined') {
        return null;
    }
    const cookiePrefix = `${COLOR_SCHEME_COOKIE_NAME}=`;
    const storedColorScheme = (_a = document.cookie
        .split(';')
        .map((cookie) => cookie.trim())
        .find((cookie) => cookie.startsWith(cookiePrefix))) === null || _a === void 0 ? void 0 : _a.slice(cookiePrefix.length);
    return storedColorScheme === 'dark' || storedColorScheme === 'light' ? storedColorScheme : null;
};
export const resolveColorScheme = () => {
    var _a;
    return (_a = getStoredColorScheme()) !== null && _a !== void 0 ? _a : getSystemColorScheme();
};
export const applyColorScheme = (colorScheme) => {
    if (typeof document === 'undefined') {
        return;
    }
    const isDarkMode = colorScheme === 'dark';
    DARK_MODE_CLASSES.forEach((className) => {
        document.documentElement.classList.toggle(className, isDarkMode);
    });
    document.documentElement.style.colorScheme = colorScheme;
};
export const storeColorScheme = (colorScheme) => {
    if (typeof document === 'undefined' || typeof window === 'undefined') {
        return;
    }
    const sharedCookieDomain = getSharedCookieDomain(window.location.hostname);
    const domainAttribute = sharedCookieDomain ? `; Domain=${sharedCookieDomain}` : '';
    const secureAttribute = window.location.protocol === 'https:' ? '; Secure' : '';
    document.cookie = `${COLOR_SCHEME_COOKIE_NAME}=${colorScheme}; Path=/; Max-Age=${COLOR_SCHEME_COOKIE_MAX_AGE}; SameSite=Lax${domainAttribute}${secureAttribute}`;
};
/**
 * Resolve and apply the current color scheme. Call once at app boot (before
 * React render) so the root classes are set as early as the JS bundle runs.
 */
export const bootstrapColorScheme = () => {
    applyColorScheme(resolveColorScheme());
};
//# sourceMappingURL=color_scheme.constants.js.map